import * as React from "react";
import { cn } from "@/lib/cn";

/**
 * The page's only <h1>, and its toolbar.
 *
 * Every screen hand-rolled the same heading beside a right-aligned row in the
 * panel this is ported from, which is how the spacing drifted between them.
 */
export function PageHeader({
  title,
  pretitle,
  description,
  children,
  className,
}: {
  title: string;
  /** Small label above the title -- Gentelella's `page-pretitle`. */
  pretitle?: string;
  description?: string;
  /** Right-aligned actions: filters, switchers, the primary button. */
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-wrap items-start justify-between gap-3", className)}>
      <div className="min-w-0">
        {pretitle && (
          <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{pretitle}</div>
        )}
        <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </div>
      {/* Wraps rather than shrinks: a toolbar of six filters must not squeeze
          the title into two characters on a narrow window. */}
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}
